function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 46,
  height: 46,
  rx: 6,
  fill: "#0081F7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5001 16.25C10.5001 26.865 19.1351 35.5 29.7501 35.5C32.9201 35.5 35.5001 32.9212 35.5001 29.75C35.5001 29.4275 35.4726 29.1075 35.4201 28.7987C35.3689 28.485 35.2914 28.18 35.1889 27.885C35.0489 27.4788 34.7076 27.1737 34.2889 27.0775L26.8326 25.3662C26.4251 25.2762 25.9926 25.39 25.6876 25.6825C25.5101 25.8525 25.5051 25.8575 24.6926 27.4088C22.0301 26.1963 19.8489 24.0225 18.5939 21.305C20.1439 20.4937 20.1476 20.49 20.3176 20.3125C20.6101 20.0075 20.7289 19.5775 20.6339 19.1675L18.9226 11.7125C18.8264 11.2925 18.5201 10.9512 18.1139 10.81C17.8164 10.7075 17.5114 10.63 17.2076 10.5812C16.8964 10.5275 16.5751 10.5 16.2501 10.5C13.0789 10.5 10.5001 13.0787 10.5001 16.25ZM13.0001 16.25C13.0001 14.4575 14.4576 13 16.2501 13C16.3864 13 16.5214 13.0087 16.6601 13.0262L17.9851 18.8025C17.7689 18.915 17.5326 19.0387 17.3139 19.1537C16.2364 19.7162 15.3864 20.1613 15.8326 21.1425C17.3014 25.325 20.6751 28.7 24.8076 30.15C25.8588 30.5732 26.2716 29.7857 26.8405 28.7003L26.8426 28.6963C26.9184 28.5497 26.999 28.396 27.0782 28.2453C27.1191 28.1673 27.1596 28.09 27.1989 28.015L32.9739 29.34C32.9914 29.475 33.0001 29.6112 33.0001 29.75C33.0001 31.5425 31.5414 33 29.7501 33C20.5139 33 13.0001 25.485 13.0001 16.25Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5001 16.25C10.5001 26.865 19.1351 35.5 29.7501 35.5C32.9201 35.5 35.5001 32.9212 35.5001 29.75C35.5001 29.4275 35.4726 29.1075 35.4201 28.7987C35.3689 28.485 35.2914 28.18 35.1889 27.885C35.0489 27.4788 34.7076 27.1737 34.2889 27.0775L26.8326 25.3662C26.4251 25.2762 25.9926 25.39 25.6876 25.6825C25.5101 25.8525 25.5051 25.8575 24.6926 27.4088C22.0301 26.1963 19.8489 24.0225 18.5939 21.305C20.1439 20.4937 20.1476 20.49 20.3176 20.3125C20.6101 20.0075 20.7289 19.5775 20.6339 19.1675L18.9226 11.7125C18.8264 11.2925 18.5201 10.9512 18.1139 10.81C17.8164 10.7075 17.5114 10.63 17.2076 10.5812C16.8964 10.5275 16.5751 10.5 16.2501 10.5C13.0789 10.5 10.5001 13.0787 10.5001 16.25ZM13.0001 16.25C13.0001 14.4575 14.4576 13 16.2501 13C16.3864 13 16.5214 13.0087 16.6601 13.0262L17.9851 18.8025C17.7689 18.915 17.5326 19.0387 17.3139 19.1537C16.2364 19.7162 15.3864 20.1613 15.8326 21.1425C17.3014 25.325 20.6751 28.7 24.8076 30.15C25.8588 30.5732 26.2716 29.7857 26.8405 28.7003L26.8426 28.6963C26.9184 28.5497 26.999 28.396 27.0782 28.2453C27.1191 28.1673 27.1596 28.09 27.1989 28.015L32.9739 29.34C32.9914 29.475 33.0001 29.6112 33.0001 29.75C33.0001 31.5425 31.5414 33 29.7501 33C20.5139 33 13.0001 25.485 13.0001 16.25Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_39940_11167)"
});

function SvgPhoneContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39940_11167",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 26,
    height: 26
  }, _ref4), _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneContact);
export default __webpack_public_path__ + "static/media/phone-contact.fce7466b.svg";
export { ForwardRef as ReactComponent };